import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TRANSCRIPT_VIEW_TYPES } from '@config/transcriptViewConfig';
import { decodeUserFromJWT, extractWatermarkData } from '@services/conferenceResource';
import { TranscriptView } from '@templates';

export class TranscriptViewPage extends PureComponent {
  componentDidMount() {
    const { match } = this.props;
    this.isAIRoute = match.path === '/transcripts/ai/:id';
    this.props.getTranscriptByLinksUUID(match.params.id, this.isAIRoute);
    if (this.user) {
      this.props.setUserToken(this.user);
    }
  }

  getUserData() {
    if (!this.user) {
      this.user = decodeUserFromJWT(this.props.match.params.id);
    }
    return this.user;
  }

  render() {
    const user = this.getUserData();
    const watermark = extractWatermarkData(user);
    return (
      <TranscriptView
        mode={TRANSCRIPT_VIEW_TYPES.FULL}
        watermark={watermark}
        isAIRoute={this.isAIRoute}
      />
    );
  }
}

TranscriptViewPage.propTypes = {
  match: PropTypes.object,
  getTranscriptByLinksUUID: PropTypes.func.isRequired,
  setUserToken: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./components/pages/TranscriptViewPage/TranscriptViewPage.js